import {videoPreviewOptions} from "./videoPreviewOptions";

export class VideoPreviewSlideShow {

    constructor($videoWrapper) {
        this.baseClass = 'video-slideshow';
        this.slideBaseClass = this.baseClass + "__slide";
        this.slideSelector = '.video-slideshow__slide--js';
        this.activeSlideClass = 'video-slideshow__slide-active--js';
        this.activeCSSSlideClass = 'video-slideshow__slide--active';
        this.activeSlideHandler = '.' + this.activeSlideClass;
        this.sliderHandler = '.video-slideshow__slider--js';
        this.slideIndexHandler = '.video-slideshow__slide-index--js';
        this.activeSlideIndicatorHandler = '.video-slideshow__slide-active-slide-indicator--js';
        this.playHandler = '.video-slideshow__slide-play--js';
        this.pauseHandler = '.video-slideshow__slide-pause--js';
        this.$videoWrapper = $videoWrapper;
        this.videoDuration = 30000;
        this.numberOfSlides = 8;
        this.timeoutDuration = this.videoDuration / this.numberOfSlides; // 30 second spot
        this.stop = false;
        this.timeout = null;

        this.$slides = this.getSlides();
        this.autoPlay();
        this.events();

        if (window.debug) window.VideoPreviewSlideShow = this;
    }

    /**
     * Stop slideshow when destructing
     * Note this doesn't mean anything in JS, and won't clean up squat, but since there aren't any event listeners in here, these classes should get cleaned up by the GC
     */
    destructor() {
        this.stop = true;
        this.immediatelyStop();
    }

    immediatelyStop() {
        clearTimeout(this.timeout);
        this.timeout = null;

        this.turnOffPlayButtons();
    }

    events() {
        let thisRef = this;

        jQuery(this.slideIndexHandler).off().click(event => {
            thisRef.jump(jQuery(event.currentTarget).attr('data-slide-index'));
        });

        jQuery(this.pauseHandler).off().click(event => {
            thisRef.immediatelyStop();
        });

        jQuery(this.playHandler).off().click(event => {
            thisRef.autoPlay();
        });
    }

    /**
     * get all slides
     * @returns jQuery object
     */
    getSlides() {
        return this.$videoWrapper.find(this.slideSelector);
    }

    /**
     * get the currently visible slide
     * @returns jQuery object
     */
    getActiveSlide() {
        return this.$videoWrapper.find(this.activeSlideHandler);
    }

    /**
     * start auto-playing
     */
    autoPlay() {

        if (this.timeout === null) {

            this.jump(0);

            let $activeSlide = this.getActiveSlide();

            if (!$activeSlide.length > 0) {
                $activeSlide = this.getFirstSlide();
            }

            $activeSlide
                .addClass(this.activeCSSSlideClass)
                .addClass(this.activeSlideClass);

            this.run();

            this.turnOnPlayButtons();
        }
    }

    turnOnPlayButtons() {
        jQuery(this.playHandler).addClass('active');
        jQuery(this.pauseHandler).removeClass('active');
    }

    turnOffPlayButtons() {
        jQuery(this.playHandler).removeClass('active');
        jQuery(this.pauseHandler).addClass('active');
    }

    /**
     * Run the recursive calls to switch slides
     */
    run() {
        let thisRef = this;

        this.timeout = setTimeout(() => {
            thisRef.next();

            if (!this.stop) {
                thisRef.run()
            }

        }, this.timeoutDuration)
    }

    /**
     * get the first slide
     * @returns jQuery object
     */
    getFirstSlide() {
        return this.getSlides().first();
    }

    /**
     * get the last slide
     * @returns jQuery object
     */
    getLastSlide() {
        return this.getSlides().last();
    }

    /**
     * takes an (optional) active slide makes it inactive
     * @param $activeSlide jQuery object
     */
    makeActiveSlideInactive($activeSlide) {
        if (!$activeSlide) {
            $activeSlide = this.getActiveSlide();
        }

        $activeSlide
            .removeClass(this.activeSlideClass)
            .removeClass(this.activeCSSSlideClass);
    }

    /**
     * Makes an inactive slide the active one
     * @param $newActiveSlide jQuery object
     */
    makeInactiveSlideActive($newActiveSlide) {
        $newActiveSlide
            .addClass(this.activeCSSSlideClass)
            .addClass(this.activeSlideClass);

        let index = $newActiveSlide.attr('data-slide-index');

        jQuery(this.activeSlideIndicatorHandler).css('left', 'calc((12.5% * ' + index + ') + 8px)')

    }

    /**
     * show the next slide
     */
    next() {
        let $newActiveSlide;
        let $activeSlide = this.getActiveSlide();

        this.makeActiveSlideInactive($activeSlide);

        if ($activeSlide.next(this.slideSelector).length) {
            $newActiveSlide = $activeSlide.next();
        } else {
            $newActiveSlide = this.getFirstSlide();
        }

        this.makeInactiveSlideActive($newActiveSlide);
    }

    /**
     * show the previous slide
     */
    prev() {
        let $newActiveSlide;
        let $activeSlide = this.getActiveSlide();

        this.makeActiveSlideInactive($activeSlide);

        if ($activeSlide.prev(this.slideSelector).length) {
            $newActiveSlide = $activeSlide.prev();
        } else {
            $newActiveSlide = this.getLastSlide();
        }

        this.makeInactiveSlideActive($newActiveSlide);
    }

    jump(slideNumber) {
        let $newActiveSlide = this.getSlide(slideNumber);
        let $activeSlide = this.getActiveSlide();
        this.makeActiveSlideInactive($activeSlide);
        this.makeInactiveSlideActive($newActiveSlide);
        this.immediatelyStop();
    }

    /**
     * @param slideNumber
     * @returns {*|jQuery}
     */
    getSlide(slideNumber) {
        return this.getSlides().eq(slideNumber)
    }
}